var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid", staticStyle: { "min-height": "600px" } },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "card" }, [
            _c(
              "div",
              { staticClass: "card-header flex-center-space-between" },
              [
                _vm.archive
                  ? _c("span", [_vm._v("Productions archivées")])
                  : _c("span", [_vm._v("Productions en cours")]),
                _vm.inventaireOuvert
                  ? _c("span", { staticClass: "text-warning" }, [
                      _c("i", {
                        staticClass: "fas fa-exclamation-triangle text-warning"
                      }),
                      _vm._v(
                        " Inventaire en cours : Sortie de stock verrouillée "
                      )
                    ])
                  : _vm._e(),
                _c("div", [
                  _vm.productions.length
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.termeDeRecherche,
                            expression: "termeDeRecherche"
                          }
                        ],
                        staticStyle: { color: "black", height: "25px" },
                        attrs: { type: "text", placeholder: "Recherche..." },
                        domProps: { value: _vm.termeDeRecherche },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.termeDeRecherche = $event.target.value
                          }
                        }
                      })
                    : _vm._e(),
                  _vm.termeDeRecherche
                    ? _c("span", {
                        staticClass: "fas fa-window-close",
                        staticStyle: {
                          position: "relative",
                          right: "28px",
                          top: "5px"
                        },
                        attrs: { title: "Effacer la recherche" },
                        on: {
                          click: function($event) {
                            _vm.termeDeRecherche = ""
                          }
                        }
                      })
                    : _vm._e()
                ])
              ]
            ),
            _c(
              "div",
              {
                staticClass: "card-content",
                attrs: { "aria-expanded": "true" }
              },
              [
                _c(
                  "div",
                  { staticClass: "card-body" },
                  [
                    _vm.showPagination
                      ? _c("b-pagination", {
                          staticClass: "flex-center-center",
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage
                          },
                          model: {
                            value: _vm.currentPage,
                            callback: function($$v) {
                              _vm.currentPage = $$v
                            },
                            expression: "currentPage"
                          }
                        })
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        !_vm.enTravail
                          ? _c("b-table", {
                              ref: "tableSuivi",
                              attrs: {
                                items: _vm.productionsAffichees,
                                fields: _vm.champsTableSuivi,
                                busy: _vm.enCreation || _vm.enRecalcul,
                                "sort-by": _vm.sortBy,
                                "sort-desc": _vm.sortDesc,
                                striped: "",
                                hover: "",
                                "sort-icon-left": "",
                                selectable: "",
                                "select-mode": "single"
                              },
                              on: {
                                "update:sortBy": function($event) {
                                  _vm.sortBy = $event
                                },
                                "update:sort-by": function($event) {
                                  _vm.sortBy = $event
                                },
                                "update:sortDesc": function($event) {
                                  _vm.sortDesc = $event
                                },
                                "update:sort-desc": function($event) {
                                  _vm.sortDesc = $event
                                },
                                "row-selected": _vm.surSelectionLigne
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(urlFichesProdPdf)",
                                    fn: function(data) {
                                      return [
                                        data.value
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "btn btn-primary",
                                                attrs: {
                                                  href: data.value,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v("Voir")]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(urlBonLivraisonPdf)",
                                    fn: function(data) {
                                      return [
                                        data.value
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "btn btn-primary",
                                                attrs: {
                                                  href: data.value,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v("Voir")]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(dateProduction)",
                                    fn: function(data) {
                                      return [
                                        data.value.indexOf("0001") == -1
                                          ? _c("span", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatHumanDate(
                                                      data.value
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(urlFichesSortiePdf)",
                                    fn: function(data) {
                                      return [
                                        data.value
                                          ? _c(
                                              "a",
                                              {
                                                staticClass: "btn btn-primary",
                                                attrs: {
                                                  href: data.value,
                                                  target: "_blank"
                                                }
                                              },
                                              [_vm._v(" Voir ")]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1943840040
                              )
                            })
                          : _c(
                              "div",
                              {
                                staticStyle: { width: "100%", height: "100%" }
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    display: "block",
                                    "margin-left": "auto",
                                    "margin-right": "auto"
                                  },
                                  attrs: {
                                    alt: "en attente",
                                    src:
                                      "/assets/images/spinners/cooking-blue-court.gif"
                                  }
                                })
                              ]
                            )
                      ],
                      1
                    ),
                    !_vm.archive
                      ? _c("div", { staticClass: "col-12" }, [
                          !_vm.enCreation && !_vm.enTravail
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mr-2",
                                  attrs: { disabled: _vm.enTravail },
                                  on: { click: _vm.creerProduction }
                                },
                                [_vm._v("Créer une mise en production")]
                              )
                            : _vm._e(),
                          _vm.enCreation
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary mr-2",
                                  on: {
                                    click: function($event) {
                                      _vm.enCreation = false
                                    }
                                  }
                                },
                                [_vm._v("Annuler la mise en production")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ])
        ])
      ]),
      _vm.enCreation
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header" }, [
                  _vm._v(" Création d'une production ")
                ]),
                _c(
                  "div",
                  {
                    staticClass: "card-content",
                    attrs: { "aria-expanded": "true" }
                  },
                  [
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-direction": "row"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mr-2",
                              staticStyle: { flex: "auto" }
                            },
                            [
                              _c("SelectDatesMenusPlansServices", {
                                attrs: {
                                  titre: "Période de consommation...",
                                  viderMenusPlans:
                                    "Désélectionner toutes les structures de menus",
                                  dropdownPosition: "bottom-top"
                                },
                                on: { "changer-dms": _vm.changementPeriode }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticStyle: { flex: "initial" } }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mr-2",
                                on: {
                                  click: function($event) {
                                    return _vm.afficherCreation()
                                  }
                                }
                              },
                              [_vm._v("Créer")]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                on: {
                                  click: function($event) {
                                    _vm.enCreation = false
                                  }
                                }
                              },
                              [_vm._v("Annuler")]
                            )
                          ])
                        ]
                      )
                    ])
                  ]
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm.productionEnCours && !_vm.enCreation
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  { staticClass: "card-header flex-center-space-between" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.productionEnCours.nom) +
                        " - " +
                        _vm._s(_vm.productionEnCours.statutTexte) +
                        " "
                    ),
                    _c("span", { attrs: { title: "Date de production" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.formatHumanDateAvecJour(
                            _vm.productionEnCours.dateProduction
                          )
                        )
                      )
                    ]),
                    _vm.productionEnCours && _vm.productionEnCours.statut <= 2
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-danger btn-sm",
                            on: { click: _vm.supprimerSuiviProduction }
                          },
                          [_vm._v(" Supprimer ")]
                        )
                      : _vm._e()
                  ]
                ),
                _c("div", { staticClass: "card-body" }, [
                  _vm.productionEnCours.statut <= 3
                    ? _c("div", { staticClass: "card-text mb-1" }, [
                        _c("span", { staticClass: "mr-2" }, [
                          _vm._v(" Etapes : ")
                        ]),
                        _vm.productionEnCours
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mr-2",
                                attrs: {
                                  disabled:
                                    _vm.enTravail ||
                                    !(_vm.productionEnCours.statut == 1)
                                },
                                on: { click: _vm.miseEnProduction }
                              },
                              [_vm._v("1. Mettre en production")]
                            )
                          : _vm._e(),
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: _vm.inventaireOuvert
                                    ? "Confirmation non disponible tant qu'un inventaire est ouvert."
                                    : ""
                                },
                                expression:
                                  "{ content: inventaireOuvert ? 'Confirmation non disponible tant qu\\'un inventaire est ouvert.' : '' }"
                              }
                            ]
                          },
                          [
                            _vm.productionEnCours
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-primary mr-2",
                                    attrs: {
                                      disabled:
                                        _vm.enTravail ||
                                        !(_vm.productionEnCours.statut == 2) ||
                                        _vm.inventaireOuvert
                                    },
                                    on: { click: _vm.atterrir }
                                  },
                                  [_vm._v("2. Confirmer la sortie de stock")]
                                )
                              : _vm._e()
                          ]
                        ),
                        _c("i", { staticClass: "fa fa-chevron-right" }),
                        _vm.productionEnCours
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary mr-2",
                                attrs: {
                                  disabled: !(_vm.productionEnCours.statut == 3)
                                },
                                on: { click: _vm.terminer }
                              },
                              [_vm._v("3. Terminer (archiver)")]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm.productionEnCours.statut > 1
                    ? _c(
                        "div",
                        {
                          staticClass: "card-texte mb-2",
                          staticStyle: { "margin-top": "8px" }
                        },
                        [
                          _c("span", { staticClass: "mr-2" }, [
                            _vm._v(" Exports : ")
                          ]),
                          _c("ToggleButton", {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: {
                                  content: "Modifier le type d'export",
                                  placement: "top"
                                },
                                expression:
                                  "{content: 'Modifier le type d\\'export', placement: 'top'}"
                              }
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              labels: { checked: "PDF", unchecked: "Excel" },
                              color: {
                                checked: "#D30943",
                                unchecked: "#1D6F42"
                              },
                              height: 30,
                              width: 80,
                              disabled: _vm.productionEnCours.statut <= 1
                            },
                            model: {
                              value: _vm.fichesEnPdf,
                              callback: function($$v) {
                                _vm.fichesEnPdf = $$v
                              },
                              expression: "fichesEnPdf"
                            }
                          }),
                          _c(
                            "b-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                variant: "outline-primary",
                                disabled:
                                  _vm.enRecalcul ||
                                  !(_vm.productionEnCours.statut == 2)
                              },
                              on: { click: _vm.lancerRecalcul }
                            },
                            [
                              _vm._v("Recalculer les documents "),
                              _c("i", {
                                class: [
                                  { "fa-spin": _vm.enRecalcul },
                                  "fa",
                                  "fa-sync-alt",
                                  "ml-2"
                                ]
                              })
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "btn-group mr-2" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      _vm.docManquant("urlFichesSortie")
                                  },
                                  on: { click: _vm.telechargerFichesSortie }
                                },
                                [
                                  _vm._v(" Fiche de sortie"),
                                  _c("i", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.productionEnCours
                                            .articlesManquants,
                                        expression:
                                          "productionEnCours.articlesManquants"
                                      }
                                    ],
                                    staticClass:
                                      "fas fa-exclamation-triangle ml-2",
                                    attrs: {
                                      title:
                                        "Articles potentiellement manquants en stock."
                                    }
                                  })
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "btn-group mr-2" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      _vm.docManquant("urlFichesProd")
                                  },
                                  on: { click: _vm.telechargerFichesProd }
                                },
                                [_vm._v("Fiche de prod.")]
                              ),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      _vm.docManquant("urlFichesProd")
                                  },
                                  on: {
                                    click:
                                      _vm.telechargerDocProdReleveTemperature
                                  }
                                },
                                [_vm._v("Relevé de temp.")]
                              ),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      _vm.docManquant("urlFichesProd")
                                  },
                                  on: {
                                    click: _vm.telechargerDocProdRefroidissement
                                  }
                                },
                                [_vm._v("Refroidissement")]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "btn-group mr-2" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      !(
                                        _vm.productionEnCours.atterrissage &&
                                        _vm.productionEnCours.atterrissage
                                          .avecPortage
                                      )
                                  },
                                  on: { click: _vm.telechargerBonDeLivraison }
                                },
                                [_vm._v("Bon de livraison")]
                              ),
                              _vm.productionEnCours.urlEtiquettesPdf
                                ? _c(
                                    "b-btn",
                                    {
                                      staticClass: "mr-1",
                                      attrs: {
                                        variant: "primary",
                                        disabled:
                                          _vm.enRecalcul ||
                                          !(
                                            _vm.productionEnCours
                                              .atterrissage &&
                                            _vm.productionEnCours.atterrissage
                                              .avecPortage
                                          )
                                      },
                                      on: { click: _vm.telechargerEtiquettes }
                                    },
                                    [_vm._v("Etiquettes (PDF uniquement)")]
                                  )
                                : _vm._e(),
                              _c(
                                "b-btn",
                                {
                                  staticClass: "mr-1",
                                  attrs: {
                                    variant: "primary",
                                    disabled:
                                      _vm.enRecalcul ||
                                      !(
                                        _vm.productionEnCours.atterrissage &&
                                        _vm.productionEnCours.atterrissage
                                          .avecPortage
                                      )
                                  },
                                  on: {
                                    click: _vm.telechargerDocProdAllotissement
                                  }
                                },
                                [_vm._v("Récap. d'allotissement")]
                              )
                            ],
                            1
                          ),
                          _vm.productionEnCours.dateGenerationDoc
                            ? _c("span", [
                                _vm._v(
                                  "Générés : " +
                                    _vm._s(
                                      _vm.formatHumanDateHeure(
                                        _vm.productionEnCours.dateGenerationDoc
                                      )
                                    )
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  (_vm.productionEnCours.atterrissage &&
                    _vm.productionEnCours.atterrissage.composantes) ||
                  !_vm.enTravailEffectifs
                    ? _c(
                        "div",
                        { staticClass: "card-text" },
                        [
                          _c("b-table", {
                            attrs: {
                              striped: "",
                              hover: "",
                              items:
                                _vm.productionEnCours.atterrissage.composantes,
                              fields:
                                this.productionEnCours.statut <= 2
                                  ? _vm.champsTableEffectif
                                  : _vm.champsTableEffectifComplet
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "cell(menu)",
                                  fn: function(data) {
                                    return [
                                      _c(
                                        "router-link",
                                        {
                                          staticStyle: { color: "#212529" },
                                          attrs: {
                                            to: {
                                              name: "Menus",
                                              params: {
                                                etablissementId:
                                                  _vm.etabCourantId,
                                                date: _vm.formatDateAvecTirets(
                                                  _vm.getLundiDeLaSemaine(
                                                    _vm.productionEnCours
                                                      .atterrissage.composantes[
                                                      data.index
                                                    ].dateUsage
                                                  )
                                                ),
                                                menuId:
                                                  "m" +
                                                  _vm.productionEnCours
                                                    .atterrissage.composantes[
                                                    data.index
                                                  ].menuId
                                              }
                                            },
                                            target: "_blank",
                                            title: "Afficher le menu"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "fas fa-external-link-alt"
                                          }),
                                          _vm._v(" " + _vm._s(data.value) + " ")
                                        ]
                                      )
                                    ]
                                  }
                                },
                                {
                                  key: "cell(dateUsage)",
                                  fn: function(data) {
                                    return [
                                      _c("AffichageDate", {
                                        attrs: {
                                          date: data.value,
                                          anneeSur2Chiffres: ""
                                        }
                                      })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(effectif)",
                                  fn: function(data) {
                                    return [
                                      _vm.archive ||
                                      _vm.productionEnCours.statut > 1 ||
                                      _vm.productionEnCours.atterrissage
                                        .composantes[data.index].avecPortage
                                        ? _c("span", [
                                            _vm._v(_vm._s(data.value))
                                          ])
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.productionEnCours
                                                    .atterrissage.composantes[
                                                    data.index
                                                  ].effectif,
                                                expression:
                                                  "productionEnCours.atterrissage.composantes[data.index].effectif"
                                              }
                                            ],
                                            attrs: { type: "number" },
                                            domProps: {
                                              value:
                                                _vm.productionEnCours
                                                  .atterrissage.composantes[
                                                  data.index
                                                ].effectif
                                            },
                                            on: {
                                              focus: function($event) {
                                                return $event.target.select()
                                              },
                                              blur: _vm.sauverEffectifs,
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.productionEnCours
                                                    .atterrissage.composantes[
                                                    data.index
                                                  ],
                                                  "effectif",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                    ]
                                  }
                                },
                                {
                                  key: "cell(effectifServi)",
                                  fn: function(data) {
                                    return [
                                      _vm.archive ||
                                      _vm.productionEnCours.atterrissage
                                        .composantes[data.index].avecPortage
                                        ? _c("span", [
                                            _vm._v(_vm._s(data.value))
                                          ])
                                        : _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.productionEnCours
                                                    .atterrissage.composantes[
                                                    data.index
                                                  ].effectifServi,
                                                expression:
                                                  "productionEnCours.atterrissage.composantes[data.index].effectifServi"
                                              }
                                            ],
                                            attrs: { type: "number" },
                                            domProps: {
                                              value:
                                                _vm.productionEnCours
                                                  .atterrissage.composantes[
                                                  data.index
                                                ].effectifServi
                                            },
                                            on: {
                                              focus: function($event) {
                                                return $event.target.select()
                                              },
                                              blur: _vm.sauverEffectifs,
                                              input: function($event) {
                                                if ($event.target.composing) {
                                                  return
                                                }
                                                _vm.$set(
                                                  _vm.productionEnCours
                                                    .atterrissage.composantes[
                                                    data.index
                                                  ],
                                                  "effectifServi",
                                                  $event.target.value
                                                )
                                              }
                                            }
                                          })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1597852274
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.enTravailEffectifs
                    ? _c(
                        "div",
                        { staticStyle: { width: "100%", height: "100%" } },
                        [
                          _c("img", {
                            staticStyle: {
                              display: "block",
                              "margin-left": "auto",
                              "margin-right": "auto"
                            },
                            attrs: {
                              alt: "en attente",
                              src:
                                "/assets/images/spinners/cooking-blue-court.gif"
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ])
        : _vm._e(),
      _c(
        "b-modal",
        {
          attrs: {
            size: "lg",
            title: "Créer une production",
            "ok-title": "Enregistrer",
            "ok-disabled":
              !_vm.nouvelleProduction.nom ||
              !_vm.nouvelleProduction.date ||
              !_vm.nouvelleProduction.dlc,
            "cancel-title": "Annuler",
            "no-close-on-backdrop": ""
          },
          on: { ok: _vm.declencherProduction },
          model: {
            value: _vm.nouvelleProduction.modalAffichee,
            callback: function($$v) {
              _vm.$set(_vm.nouvelleProduction, "modalAffichee", $$v)
            },
            expression: "nouvelleProduction.modalAffichee"
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c("div", { staticClass: "form-group" }, [
              _c("label", { attrs: { for: "nomCommande" } }, [
                _vm._v("Nom de votre production")
              ]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.nouvelleProduction.nom,
                    expression: "nouvelleProduction.nom",
                    modifiers: { trim: true }
                  }
                ],
                staticClass: "form-control",
                attrs: { id: "nomCommande", type: "text" },
                domProps: { value: _vm.nouvelleProduction.nom },
                on: {
                  focus: function($event) {
                    return $event.target.select()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.nouvelleProduction,
                      "nom",
                      $event.target.value.trim()
                    )
                  },
                  blur: function($event) {
                    return _vm.$forceUpdate()
                  }
                }
              }),
              !_vm.nouvelleProduction.nom
                ? _c("div", { staticClass: "error" }, [
                    _vm._v("Vous devez indiquer un nom pour cette production")
                  ])
                : _vm._e()
            ]),
            _c(
              "div",
              { staticClass: "datepicker-trigger form-group" },
              [
                _c("label", [_vm._v("Date de Production")]),
                _c("br"),
                _c("v-date-picker", {
                  staticClass: "date-picker",
                  attrs: {
                    columns: 1,
                    step: 1,
                    popover: { visibility: "click" }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(ref) {
                        var inputValue = ref.inputValue
                        var inputEvents = ref.inputEvents
                        return [
                          _c(
                            "input",
                            _vm._g(
                              {
                                domProps: {
                                  value: inputValue
                                    ? inputValue
                                    : "Date de production..."
                                }
                              },
                              inputEvents
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.nouvelleProduction.date,
                    callback: function($$v) {
                      _vm.$set(_vm.nouvelleProduction, "date", $$v)
                    },
                    expression: "nouvelleProduction.date"
                  }
                }),
                !_vm.nouvelleProduction.date
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("La date de production doit être indiquée")
                    ])
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "form-group",
                staticStyle: { "margin-bottom": "15px" }
              },
              [
                _c("label", [_vm._v("DLC / DDM")]),
                _c("br"),
                _vm._v(" J + "),
                _c("InputNumber", {
                  key: _vm.nouvelleProduction.dlc,
                  staticStyle: { width: "70px" },
                  attrs: { typeFiltre: "quantiteEntiere" },
                  model: {
                    value: _vm.nouvelleProduction.dlc,
                    callback: function($$v) {
                      _vm.$set(_vm.nouvelleProduction, "dlc", $$v)
                    },
                    expression: "nouvelleProduction.dlc"
                  }
                }),
                _vm.nouvelleProduction.dlc <= 0 || !_vm.nouvelleProduction.dlc
                  ? _c("div", { staticClass: "error" }, [
                      _vm._v("Une DLC doit être supérieure à 0")
                    ])
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }